import React, { useState, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

const LazyLoadedComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0 // Trigger when any part of the component is in view
  })

  const [hasRendered, setHasRendered] = useState(false)

  useEffect(() => {
    if (inView && !hasRendered) {
      setHasRendered(true)
    }
  }, [inView, hasRendered])

  return <div ref={ref}>{hasRendered && children}</div>
}

export default LazyLoadedComponent
